import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import SetPassword from './pages/SetPassword';
import Dashboard from './pages/Dashboard';
import Today from './pages/Today';
import Leads from './pages/Leads';
import Accounts from './pages/Accounts';
import Tasks from './pages/Tasks';
import Meetings from './pages/Meetings';
import Settings from './pages/Settings';
import PmApp from './pm/PmApp';
import './App.css';

// tasks.* subdomaininde Task Yönetim uygulaması; diğer her yerde CRM.
const IS_TASKS = typeof window !== 'undefined' && /^tasks[.-]/.test(window.location.hostname);
if (typeof document !== 'undefined') document.title = IS_TASKS ? 'BoldRanks Tasks' : 'Boldranks CRM';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ background: '#0E0F11', minHeight: '100vh' }} />;
  return user ? <Layout>{children}</Layout> : <Navigate to="/login" />;
};

const PmPrivate = () => {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ background: '#0E0F11', minHeight: '100vh' }} />;
  return user ? <PmApp /> : <Navigate to="/login" />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="bottom-center" toastOptions={{
          style: { background: 'var(--card-hover)', color: 'var(--text)', border: '1px solid var(--border-strong)', fontSize: 13 },
        }} />
        {IS_TASKS ? (
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/sifre" element={<SetPassword />} />
            <Route path="/*" element={<PmPrivate />} />
          </Routes>
        ) : (
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/sifre" element={<SetPassword />} />
            <Route path="/today" element={<PrivateRoute><Today /></PrivateRoute>} />
            <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/leads" element={<PrivateRoute><Leads /></PrivateRoute>} />
            <Route path="/accounts" element={<PrivateRoute><Accounts /></PrivateRoute>} />
            <Route path="/tasks" element={<PrivateRoute><Tasks /></PrivateRoute>} />
            <Route path="/meetings" element={<PrivateRoute><Meetings /></PrivateRoute>} />
            <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
            <Route path="/" element={<Navigate to="/today" />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        )}
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
